import React from 'react';
import Notification from '../../../components/Notification/Notification';
import { useChampionsLeagueData } from './hooks';
import { PhaseControls } from './components';
import './ChampionsLeagueAdminExtended.css';

const ChampionsLeaguePhaseControlsAdmin = () => {
  const championsLeagueData = useChampionsLeagueData();

  return (
    <div className="champions-league-admin-extended">
      <Notification
        open={!!championsLeagueData.error}
        onClose={() => championsLeagueData.setError(null)}
        message={championsLeagueData.error}
        type="error"
      />

      <Notification
        open={!!championsLeagueData.success}
        onClose={() => championsLeagueData.setSuccess(null)}
        message={championsLeagueData.success}
        type="success"
      />

      <PhaseControls
        currentPhaseLocks={championsLeagueData.currentPhaseLocks}
        onSuccess={championsLeagueData.setSuccess}
        onError={championsLeagueData.setError}
      />
    </div>
  );
};

export default ChampionsLeaguePhaseControlsAdmin;
